import { Link } from "react-router-dom"
import { Button } from "./Button"
import { COMMUNITY_URL } from "~/constants"
import { shortAddress } from "~/utils/shortAddress"
import { useAccount } from "~/hooks/useAccount"
import { WalletButton } from './WalletButton'

export const GlobalNav = () => {
  const { account } = useAccount()

  return (
    <div className="sticky top-0 z-10 bg-[#080c0d]" style={{ borderBottom: '1px solid rgb(255 255 255 / 0.1)'}}>
      <div className="flex items-center w-full gap-4 px-10 h-20">
        <div className="flex justify-start items-center flex-grow relative gap-4">
          <Link to="/">
            <svg
              width={36}
              height={36}
              viewBox="0 0 36 36"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="w-9 h-9"
              preserveAspectRatio="none"
            >
              <g filter="url(#filter0_d_642_1765)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M9.95879 32.3288C7.85487 33.551 5.22003 32.0299 5.22003 29.5931L5.22003 2.34002L9.72842 5.05049L9.72842 27.042C9.72842 27.1306 9.82412 27.1862 9.90104 27.1422L26.1005 17.8855C26.1792 17.8405 26.1776 17.7263 26.0976 17.6836L18.285 13.5117C18.2081 13.4706 18.1153 13.5263 18.1153 13.6134V17.9699L13.6069 20.6804L13.6069 11.1631C13.6069 8.77633 16.1449 7.24993 18.247 8.37246L30.5484 14.9415C32.7323 16.1077 32.7879 19.2241 30.647 20.4678L9.95879 32.3288Z"
                  fill="#60E25E"
                />
              </g>
              <defs>
                <filter
                  id="filter0_d_642_1765"
                  x="4.98928"
                  y="2.10928"
                  width="27.4615"
                  height="30.8815"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity={0} result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset />
                  <feGaussianBlur stdDeviation="0.115374" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.0745098 0 0 0 0 0.996078 0 0 0 0 0.258824 0 0 0 0.8 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_642_1765"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_642_1765"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </Link>
          <div className="flex justify-start items-center gap-2">
            <a href={COMMUNITY_URL.DOCS} target="_blank" rel="noreferrer" className="flex justify-center items-center relative gap-2.5 px-3 py-2">
              <p className="text-base font-semibold text-left text-white">
                Docs
              </p>
            </a>
            <a href={COMMUNITY_URL.DISCORD} target="_blank" rel="noreferrer" className="flex justify-start items-center relative gap-2.5 p-2">
              <svg
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6 relative"
                preserveAspectRatio="none"
              >
                <path
                  d="M18.2813 6.26558C20.3142 9.27296 21.3181 12.6652 20.9428 16.5705C20.9413 16.587 20.9327 16.6022 20.9192 16.6121C19.3798 17.7495 17.8882 18.4398 16.4176 18.8975C16.4062 18.901 16.3939 18.9009 16.3826 18.897C16.3713 18.8931 16.3614 18.8858 16.3544 18.876C16.0147 18.4004 15.706 17.8989 15.4355 17.3723C15.42 17.3413 15.4342 17.304 15.4661 17.2918C15.9564 17.1059 16.4226 16.8831 16.871 16.6194C16.9063 16.5985 16.9086 16.5476 16.876 16.5232C16.7808 16.4521 16.6865 16.3774 16.5963 16.3026C16.5794 16.2888 16.5567 16.2861 16.5376 16.2954C13.6263 17.6481 10.4371 17.6481 7.49145 16.2954C7.47233 16.2868 7.4496 16.2897 7.43318 16.3033C7.34318 16.378 7.24868 16.4521 7.1544 16.5232C7.12178 16.5476 7.12448 16.5985 7.16003 16.6194C7.60845 16.8781 8.07465 17.1059 8.56425 17.2927C8.59597 17.3049 8.61105 17.3413 8.5953 17.3723C8.3307 17.8996 8.022 18.4011 7.67595 18.8767C7.66087 18.896 7.63613 18.9048 7.61272 18.8975C6.1491 18.4398 4.65758 17.7495 3.11813 16.6121C3.10531 16.6022 3.09608 16.5863 3.09473 16.5698C2.78108 13.1918 3.42031 9.77148 5.75378 6.2649C5.7594 6.25562 5.76795 6.24837 5.77785 6.24407C6.92603 5.71386 8.1561 5.32379 9.44175 5.10102C9.46515 5.0974 9.48855 5.10827 9.5007 5.12909C9.65955 5.41208 9.84112 5.77499 9.96397 6.07156C11.3191 5.86328 12.6955 5.86328 14.079 6.07156C14.2018 5.78133 14.3771 5.41208 14.5353 5.12909C14.5409 5.11876 14.5497 5.11048 14.5602 5.10544C14.5708 5.1004 14.5827 5.09885 14.5942 5.10102C15.8806 5.32447 17.1106 5.71454 18.2579 6.24407C18.268 6.24837 18.2764 6.25562 18.2813 6.26558ZM10.6529 12.6883C10.6671 11.6897 9.9435 10.8634 9.03517 10.8634C8.13427 10.8634 7.41765 11.6824 7.41765 12.6883C7.41765 13.6939 8.14845 14.513 9.03517 14.513C9.9363 14.513 10.6529 13.6939 10.6529 12.6883ZM16.6339 12.6883C16.648 11.6897 15.9244 10.8634 15.0163 10.8634C14.1152 10.8634 13.3986 11.6824 13.3986 12.6883C13.3986 13.6939 14.1294 14.513 15.0163 14.513C15.9244 14.513 16.6339 13.6939 16.6339 12.6883Z"
                  fill="white"
                />
              </svg>
            </a>
            <a href={COMMUNITY_URL.X} target="_blank" rel="noreferrer" className="flex justify-start items-center relative gap-2.5 p-2">
              <svg
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6 relative"
                preserveAspectRatio="none"
              >
                <g clipPath="url(#clip0_642_1776)">
                  <path
                    d="M16.6009 4H19.0544L13.6943 10.7774L20 20H15.0627L11.1957 14.4066L6.77087 20H4.31595L10.049 12.7508L4 4H9.06262L12.5581 9.11262L16.6009 4ZM15.7399 18.3754H17.0993L8.32392 5.53928H6.86506L15.7399 18.3754Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_642_1776">
                    <rect width={24} height={24} fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </a>
          </div>
        </div>

        <div className="flex items-center gap-4">
          <Button to="/games/create">
            <div className="flex items-center gap-1">
              <svg
                width={16}
                height={16}
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="flex-grow-0 flex-shrink-0 w-4 h-4 relative"
                preserveAspectRatio="none"
              >
                <path d="M8 4L8 12M12 8L4 8" stroke="#080C0D" strokeWidth="1.33333" strokeLinecap="round" />
              </svg>
              <p className="flex-grow-0 flex-shrink-0 text-base font-bold text-justify text-[#19191b]">
                Create Game
              </p>
            </div>
          </Button>

          {/* {account?.github && (
            <Button type="tertiary">
              <div className="flex items-center gap-2">
                <img
                  className="border border-solid border-white/60 w-5 h-5 rounded-full"
                  src={account.github?.avatar}
                  alt={account.github?.name}
                />
                <span>
                  {account.github?.name}
                </span>
                <svg
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="flex-grow-0 flex-shrink-0 w-6 h-6 relative"
                  preserveAspectRatio="none"
                >
                  <path
                    d="M7 10L12.0008 14.58L17 10"
                    stroke="white"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </Button>
          )} */}

          <WalletButton />
        </div>
        {/* <Button requiresWalletConnection>
          Connect
        </Button> */}
      </div>
    </div>
  )
}
